import iziToast from 'izitoast'

iziToast.settings({
  position: 'topCenter',
  timeout: 1000
})

class alertHelper {
  static success (string) {
    string = string || 'Success'
    iziToast.success({
      message: string
    })
  }

  static warning (string) {
    string = string || 'Warning'
    iziToast.warning({
      message: string
    })
  }

  static error (string = 'Error') {
    string = string || 'Error'
    iziToast.error({
      message: string
    })
  }
}

export default alertHelper
